<template>
  <div>
    <div v-if="detail_loader" style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31);z-index: 1000">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <!--    <v-layout justify-end>-->
<!--      <v-flex xs12 md3>-->
<!--        <v-menu-->
<!--            ref="menu"-->
<!--            v-model="filterDateMenu"-->
<!--            :close-on-content-click="false"-->
<!--            :nudge-right="40"-->
<!--            :return-value.sync="date"-->
<!--            lazy-->
<!--            transition="scale-transition"-->
<!--            offset-y-->
<!--            full-width-->
<!--            min-width="290px"-->
<!--        >-->
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-text-field-->
<!--                v-model="date"-->
<!--                label="Date"-->
<!--                prepend-icon="event"-->
<!--                readonly-->
<!--                v-on="on"-->
<!--            ></v-text-field>-->
<!--          </template>-->
<!--          <v-date-picker v-model="date" no-title scrollable  @input="filterDateMenu = false">-->
<!--&lt;!&ndash;            <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;            <v-btn flat color="primary" @click="filterDateMenu = false">Cancel</v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>&ndash;&gt;-->
<!--          </v-date-picker>-->
<!--        </v-menu>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
    <v-expansion-panel class="mb-4">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Filters</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs12 md3>
                <v-text-field
                    solo
                    v-model="filters.number"
                    label="Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3>
                <v-menu
                    ref="menu"
                    v-model="filterDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="filters.date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="filters.date"
                        label="Date"
                         append-icon="event"
                        readonly solo
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.date" no-title
                                 :max="maxDate" :min ="minDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="filterDateMenu = false">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.menu.save(filters.date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <!--                                <v-flex xs12 md3>-->
              <!--                                    <v-select-->
              <!--                                        outline-->
              <!--                                        v-model="filters.exceptionDays"-->
              <!--                                        :loading="loading.exceptionDays"-->
              <!--                                        :items="exceptionDays"-->
              <!--                                        multiple-->
              <!--                                        item-text="name"-->
              <!--                                        item-value="id"-->
              <!--                                        label="Line"-->
              <!--                                    ></v-select>-->
              <!--                                </v-flex>-->
              <v-flex xs12 md3 justify-center>
                <v-btn @click="applyFilters" color="primary" class="mt-3">
                  Filter
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs6>
              <span class="headline">Live Location</span>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
                <v-flex xs12 v-if="liveLocation && liveLocation!= null && liveLocation.start_date == today && (liveLocation.journey_status == 'journey_ongoing' || liveLocation.journey_status == 'location_disabled')">
                  <v-btn flat :class="liveLocation.journey_status == 'journey_ongoing' ? 'primary':'is-outlined'"  class="mx-0" :disabled="current_time > this.last_stop_time"  @click="changeStatus('on')">ON</v-btn>
                  <v-btn flat :class="liveLocation.journey_status == 'location_disabled'  ? 'primary':'is-outlined'" class="mx-0"  @click="changeStatus('off')">OFF</v-btn>
                </v-flex>
                <span v-else>
<!--                <span class="light-green accent-2 text-center" style="padding:5px" v-if="liveLocation.journey_status == 'journey_completed'">Journey Completed </span>-->
<!--                <span v-if="liveLocation.journey_status == 'location_disabled'">Location Disabled </span>-->
              </span>
            </v-flex>

          </v-card-title>
          <v-card-text>
            <v-layout v-if="liveLocation">
              <v-flex xs12 md6 lg3>
                <span class="font-weight-bold">Train Number</span>
                <br>
                {{ liveLocation.train_number }}
              </v-flex>
              <v-flex xs12 md6 lg3>
                <span class="font-weight-bold">From / To</span>
                <br>
                {{ train.first_station_name }}
                to
                {{ train.last_station_name }}
                ({{scheduleStartTime}})
              </v-flex>
              <v-flex xs12 md6 lg3>
                <span class="font-weight-bold">Updated At</span>
                <br>
                {{ liveLocation.time | appTimeFormat }}
              </v-flex>
              <v-flex xs12 md6 lg3>
                <span class="font-weight-bold">Position</span>
                <br>
                {{ nearestPosition[liveLocation.nearest_station_position] }} {{ liveLocation.nearest_station_name
                  ? liveLocation.nearest_station_name : '' }}
              </v-flex>
              <v-flex xs12 md6 lg3>
                <span class="font-weight-bold">Current Status</span>
                <br>
                {{ trainStatus[liveLocation.train_status] }}
              </v-flex>
<!--              <v-flex xs12 md6 lg3>-->
<!--                <span class="font-weight-bold">Accuracy</span>-->
<!--                <br>-->
<!--                {{ accuracyStatus[liveLocation.train_accuracy_status] }}-->
<!--              </v-flex>-->
            </v-layout>
            <v-layout v-else>
              <h3>Live Location only available for today</h3>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            <span class="subheading pt-3">Activities</span>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="activitySearch"
                append-icon="search"
                label="Search Station"
                single-line
                hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
                no-results-text="Loading... Please wait"
                :headers="activityHeaders"
                :items="searchedActivities"
                item-key="id"
                :loading="loading.data"
                :total-items="activityTotalItems"
                :pagination.sync="activityPagination"
                :rows-per-page-items="[10, 20, 50, 100]"
            >
              <template slot="items" slot-scope="props">
                <td>
                  {{ props.item.time | appTimeFormat }}
                </td>
<!--                <td>-->
<!--                  {{ props.item.speed }}-->
<!--                </td>-->
                <td>
                  {{ props.item.nearest_station_name }} ({{ props.item.station_name }})
                </td>
                <td>
                  {{ nearestPosition[props.item.nearest_station_position] }}
                </td>
                <td>
                  {{ trainStatus[props.item.train_status] }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card>
          <v-card-title>
            <span class="subheading pt-3">Timings</span>
          </v-card-title>
          <v-card-text>

            <v-data-table
                no-results-text="Loading... Please wait"
                :headers="liveTimingHeaders"
                :items="liveTimings"
                item-key="id"
                :loading="loading.data"
                :rows-per-page-items="[10, 20, 50, 100]"
            >
              <template slot="items" slot-scope="props">
                <td>
                  {{ props.item.name }}
                </td>
                <td>
                  {{ props.item.scheduled_time }}
                </td>
                <td>
                  {{ props.item.expected_time }}
                </td>
                <td>
                  {{ props.item.actual_time }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
        v-model="location_status"
        scrollable
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
        persistent
    >
      <v-card>
        <v-form>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md12 lg12>
                <h3>Are you sure you want to {{ this.selected_status }} the live location?</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="updateLocationStatus()">OK</v-btn>
            <v-btn small color="black" flat type="reset" @click="location_status = !location_status">
              Cancel
            </v-btn>

          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-snackbar
        :color="snackBar.color"
        :top="snackBar.top"
        :bottom="snackBar.bottom"
        :left="snackBar.left"
        :right="snackBar.right"
        v-model="snackBar.show"
    >
      {{ snackBar.message }}
      <v-btn dark flat @click.native="snackBar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Details",
  watch: {
    'date': function () {
      this.$router.replace(this.$route.path+'?date='+this.date)
    },
    activityPagination: {
      handler() {
        this.getActivitiesData();
      },
      deep: true
    },
  },
  computed: {
    searchedActivities() {
      if(this.activities.length > 0){
        return this.activities.filter((activity) => activity.nearest_station_name.toLowerCase().includes(this.activitySearch.toLowerCase()))
      }else{
        return this.activities;
      }
    },
    scheduleStartTime() {
      if(this.liveTimings.length > 0){
        let timeBreakDown = this.liveTimings[0].scheduled_time.split(':');
        let hours = timeBreakDown[0] > 12 ? (timeBreakDown[0] % 12) : timeBreakDown[0]
        let mins = timeBreakDown[1]
        let amPm = timeBreakDown[0] >= 12 ? 'pm' : 'am'
        return hours+':'+mins+' '+amPm;
      }

    }
  },
  methods: {
    changeStatus(val){
        if(val == 'on' && this.liveLocation.journey_status == 'journey_ongoing'){
          this.location_status = false;
        }else if(val == 'off' && this.liveLocation.journey_status == 'location_disabled'){
          this.location_status = false;
        }else{
          this.location_status = true;
        }

        if(val == 'off'){
          this.selected_status = 'disable';
        }else{
          this.selected_status = 'enable';
        }


    },
    applyFilters() {
      this.allSelected = false
      this.unCheckedRows = []
      this.$route.params.number = this.filters.number
      this.date = this.filters.date
      this.getData(this.is_filter)
      this.getActivitiesData(this.is_filter)
      this.$router.replace({ path: this.filters.number, query: { date: this.filters.date }})
    },
    getData() {
      this.loading.data = true;
      this.filters.date = this.date;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/web/train-tracking/${this.$route.params.number}?date=${this.date}`)
          .then((response) => {
            if (response.data.status == 1) {
              this.liveLocation = response.data.data.live_location

              this.liveTimings = response.data.data.live_timings;
              this.train = response.data.data.train
              this.last_stop_time = response.data.data.last_stop_time
            }
          })
          .catch((error) => {

          })
          .finally(() => {
            {
              this.loading.data = false;
            }
          });
    },
    getActivitiesData() {

      this.loading.data = true;

      axios.get(
        `${process.env.VUE_APP_API_URL}/api/v1/web/train-tracking-activities/${this.$route.params.number}`,
        {
          params: {
            date: this.date,
            page: this.activityPagination.page,
            per_page: this.activityPagination.rowsPerPage
          }
        }
      )
      .then((response) => {

        if (response.data.status == 1) {

          this.activities = response.data.activities.data;
          this.activityTotalItems = response.data.activities.total;
        }
      })
      .finally(() => {
        this.loading.data = false;
      });
    },

    updateLocationStatus(){
      this.detail_loader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/web/change-status`, {train_number:this.liveLocation.train_number,status:this.selected_status},{headers:this.$headers}).then((response)=>{
            // if (response.data.status == 1) {
            //   this.snackBar.message = response.data.message;
            //   this.snackBar.show = true;
            // }
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.detail_loader = false;
              this.location_status = false;
              this.getData();
              this.getActivitiesData();
          })
          .catch((error) => {

          })
          .finally(() => {
            {
              this.loading.data = false;
            }
          });


    }
  },
  mounted() {
    this.date = this.$route.query.date ? this.$route.query.date : moment().format('YYYY-MM-DD')
    this.getData();
  },
  data() {
    return {
      detail_loader:false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      nearestPosition: {
        0: 'Left',
        1: 'Arriving at',
        2: 'At'
      },
      accuracyStatus: {
        0: 'Less Accurate',
        1: 'Accurate'
      },
      trainStatus: {
        0: 'Stopped',
        1: 'Moving'
      },
      activitySearch: '',
      train: {
        first_station_name: null,
        last_station_name: null,
      },
      activityHeaders: [
        {
          text: "Time",
          value: "time",
          align: "left",
          sortable: false,
        },
        // {
        //   text: "Current Speed",
        //   value: "local_train_tracking_activities.speed",
        //   sortable: false,
        // },
        {
          text: "Nearest Station",
          value: "nearest_station_name",
          align: "left",
          sortable: false,
        },
        {
          text: "Position",
          value: "position",
          align: "left",
          sortable: false,
        },
        {
          text: "Train Status",
          value: "train_status",
          sortable: false,
        },
        // {
        //   text: "Accuracy",
        //   value: "train_accuracy_status",
        //   sortable: false,
        // },
      ],
      liveTimingHeaders: [
        {
          text: "Station",
          value: "station",
          sortable: false,
        },
        {
          text: "Scheduled Time",
          value: "scheduled_time",
          sortable: false,
        },
        {
          text: "Expected Time",
          value: "expected_time",
          sortable: false,
        },
        {
          text: "Actual Time",
          value: "scheduled_time",
          sortable: false,
        },
      ],
      liveLocation: {},
      liveTimings: [],
      currentPage: 1,
      activities: [],
      activityTotalItems: 0,
      activityPagination: { rowsPerPage: 10 },

      location_status:false,
      selected_status:'',
      loading: {
        data: false
      },
      date: null,
      today: moment().format('YYYY-MM-DD'),
      current_time: moment().format('YYYY-MM-DD H:m:00'),
      filterDateMenu: false,
      is_filter:false,
      filters: {
        number: '',
        date: moment().format('YYYY-MM-DD')
      },
      minDate : moment().subtract(2, "days").format('YYYY-MM-DD'),
      maxDate: moment().format('YYYY-MM-DD')
    }
  },
}
</script>
<style>
.is-outlined{
  border-right: 1px solid #2F80ED;
  border-top: 1px solid #2F80ED;
  border-bottom: 1px solid #2F80ED;
  border-left: 1px solid #2F80ED;
  background-color: #ffffff !important;
  color: #2F80ED !important;
  box-shadow: none !important;
}
</style>
